import { render, staticRenderFns } from "./NewProductBadge.vue?vue&type=template&id=9055a1fa&scoped=true"
import script from "./NewProductBadge.vue?vue&type=script&lang=js"
export * from "./NewProductBadge.vue?vue&type=script&lang=js"
import style0 from "./NewProductBadge.vue?vue&type=style&index=0&id=9055a1fa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9055a1fa",
  null
  
)

export default component.exports